import {types} from "../actions/types";

const initialState = {
    prefersDarkMode: true,
    logo_light: null,
    logo_dark: null,
};


export const configHanuThemeReducer = (state = initialState, action) => {
    switch (action?.type) {
        case types.updateConfigHanuTheme:
            return {...state, ...action.payload};
        case types.updatePreferDarkMode:
            return {...state, prefersDarkMode: action.payload};
        case types.deleteConfigHanuTheme:
            return {initialState, prefersDarkMode: state.prefersDarkMode}
        default:
            return state;
    }
};
